import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tourParticipantCustomFieldsApi from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.ts';
import { tourParticipantCustomFieldsApiQueryKeys } from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.queryKeys.ts';

const useReorderCustomFields = (tourId: string) => {
  const queryClient = useQueryClient();
  const queryKey = tourParticipantCustomFieldsApiQueryKeys.allForTour(tourId);

  return useMutation<void, Error, string[], { toastId: string | number }>({
    mutationFn: (fieldIds) =>
      tourParticipantCustomFieldsApi.reorderFields(tourId, fieldIds),
    onMutate: () => ({
      toastId: toast.loading('Zapisywanie kolejności...'),
    }),
    onSuccess: (_data, _variables, context) => {
      toast.success('Kolejność została zapisana', { id: context?.toastId });
    },
    onError: (error, _variables, context) => {
      toast.error('Nie udało się zmienić kolejności pól', {
        id: context?.toastId,
        description: error.message,
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
};

export default useReorderCustomFields;
